import React from "react";
import { useCart } from "../context/cart";
import toast from "react-hot-toast";

const AddToCart = ({ p }) => {
  const [cart, setCart] = useCart();
  return (
    <button
      className="btn btn-dark ms-1"
      onClick={() => {
        setCart([...cart, p]);
        localStorage.setItem("cart", JSON.stringify([...cart, p]));
        toast.success("Item Added to cart");
      }}
    >
      ADD TO CART
    </button>
  );
};

export default AddToCart;
